import { IItemAttributeResourceCalculationKey } from '../../interfaces/iitem-attribute-resource-calculation-key';
import { ItemAttribute } from '../item-attribute';
import { ResourceCalculation } from '../resource-calculation';

export class ItemAttributeResourceCalculationKeyBase {
  ItemAttributeResourceCalculationKeyId: number;
  ItemAttributeId: number;
  ResourceCalculationId: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ItemAttribute?: ItemAttribute;
  ResourceCalculation?: ResourceCalculation;

  constructor(item?: IItemAttributeResourceCalculationKey) {
    if (item) {

      this.ItemAttributeResourceCalculationKeyId = item.ItemAttributeResourceCalculationKeyId;
      this.ItemAttributeId = item.ItemAttributeId;
      this.ResourceCalculationId = item.ResourceCalculationId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ItemAttribute = new ItemAttribute(item.ItemAttribute);
      this.ResourceCalculation = new ResourceCalculation(item.ResourceCalculation);
    }
  }
}